import styled from 'styled-components';
import { colourPalette } from 'styles/styles';
export const CreditsModalTopupFormTotalToPayStyle = {
  Container: styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    padding-top: 24px;
    margin-top: 24px;
    border-top: 1px solid ${colourPalette.neutral300};
  `,
  Content: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    & > p {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${colourPalette.neutral600};
      margin: 0;
    }
  `,
  Message: styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: ${colourPalette.neutral500};
  `,
};
